import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Form, Button, Alert } from 'react-bootstrap'
import axios from "axios";
import '../styles/FormForgotUser.css';
import '../../App.css';

export default function FormForgotUser(){
    useEffect(() => {
        document.title = "Forgot Account"; // Set the tab name
    }, []);

    const navigate = useNavigate();
    const location = useLocation();
    
    const [formAnswered, setFormAnswered] = useState(false);
    const [errorAttempt, setErrorAttempt] = useState({
        type: "",
        message: ""
    }); 
    const [text_response, setResponseText] = useState('');
    const [otpDigits, setOtpDigits] = useState(new Array(6).fill(""));
    const [input_data, setInputs] = useState({});

    const otpRefs = useRef([]);

    // please refer to state_email in Login.js
    const state_email = location.state ? location.state.email : ' ';

    const getStatusResponse = (statusResponse) => {
        switch (statusResponse) {
          case 0:
            return "danger";
          case 1:
            return "success";
          default:
            return "warning";
        }
      };

    const handleOtpChange = (value, index) =>
        {
        // Update the specific digit in the OTP array
        const updatedOtp = [...otpDigits];
        updatedOtp[index] = value.slice(-1); // Only keep the last entered digit
        setOtpDigits(updatedOtp);

        if (value && index < otpRefs.current.length - 1) {
            otpRefs.current[index + 1]?.focus(); // Move focus to the next input
        }
        };


    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace') {
            if (!otpDigits[index] && index > 0) {
                // If current input is empty, move focus back
                otpRefs.current[index - 1]?.focus();
            }
        } else if (e.key === 'Delete') {
            if (!otpDigits[index] && index < otpRefs.current.length - 1) {
                // If current input is empty, move focus forward (on delete key)
                otpRefs.current[index + 1]?.focus();
            }
        }
    };

    const changeValues = (event) =>
        {
            const { name, value } = event.target;
            setInputs
            (
                (oldInputs) =>
                ({
                    ...oldInputs,
                    [name] : value
                })
            );
        };
    
    const submit_otp = (e) => {
        e.preventDefault();
        const otpString = otpDigits.join(""); // Combine the digits into a single string
        //console.warn("Submitted OTP:", otpString);
        
        axios.post('https://docuquest-swu.swucite.tech/api_drts/checkOtp.php', {
            otp: otpString,
            email: input_data.forgotEmail
        })
        .then((response) => {
            //console.warn(response.data);
            setResponseText(response.data);
            if (response.data.status === 1) {                
                navigate('/forgot/recover', {
                    state: { recoverAccount: input_data.forgotEmail }
                });
            }
        })
        .catch((err) => {
            setResponseText({
                status: 0,
                message: err
            })
        });
    }

    const attempt_recovery = (e) => // TODO add cooldown for resetting password
        {
            e.preventDefault();

            axios.post('https://docuquest-swu.swucite.tech/api_drts/recoverAccount.php', {
                forgotEmail: input_data.forgotEmail,  
            })
            .then((response)=>{
                setResponseText(response.data);
                if(response.data.status === 1){
                 setFormAnswered(true); // switch from form 1 to form 2
                 setErrorAttempt({
                    type:"success",
                    message:`Found an account for ${input_data.forgotEmail}: ${response.data.message}`
                 });
                } else {
                 setErrorAttempt({
                    type:"danger",
                    message:`${response.data.message}`
                 });
                }
            })
            .catch((err)=>{
                setErrorAttempt({
                    type:"danger",
                    message:`ERROR in finding email: ${err}`
                });
            })
        };    

    return (
        <section className="form-forgot">
        {!formAnswered ? (
            // form 1
            <div className="container-4">
                <h2 className="mb4">Let's check if account exists</h2>
                {errorAttempt ? (
                    <Alert variant={errorAttempt.type}>
                        {errorAttempt.message}
                    </Alert>
                ) : ""
                }
                <Form onSubmit={attempt_recovery}>
                    <Form.Group>
                        <Form.Label htmlFor="forgotEmail">Enter your last email address</Form.Label>
                        <Form.Control 
                        required
                        type="email" 
                        name="forgotEmail" 
                        defaultValue={state_email}
                        onChange={changeValues} 
                        placeholder="forgotaccount.swu@phinmaed.com"
                        />
                    </Form.Group>
                    <Form.Group className="mt-3">
                        <Button as="input" type="submit" variant="primary" value={'Find account'} />
                    </Form.Group>
                </Form>
            </div>
        ) : (
            // form 2
            <div className="otp-content">
               {text_response && (
                <Alert variant={getStatusResponse(text_response.status)}>
                    {text_response.message}
                </Alert>
                )}
                <p>Fill in the OTP that was sent to your email.</p>
                {/* TODO link to resend OTP + cooldown */}
                <br/>
                <section>
                    <Form onSubmit={submit_otp}>
                    {/* TODO combine values of form fields to create otp string */}
                    <div className="otp-container">
                        {[...Array(6)].map((_, index) => (
                            <Form.Control
                                key={index}
                                type="tel"
                                className="otp-unit"
                                value={otpDigits[index]}
                                onChange={(e) => handleOtpChange(e.target.value.replace(/[^0-9]/g, ''), index)} // Update the corresponding digit
                                // onKeyPress={(e) => {
                                //     if (!/[0-9]/.test(e.key)) {
                                //         e.preventDefault(); // Block non-numeric input
                                //     }
                                // }}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                                placeholder="*"
                                maxLength="1"
                                pattern="[0-9{1}]"
                                ref={(el) => (otpRefs.current[index] = el)}
                            />
                        ))}
                    </div>

                    <Form.Group className="mt-3">
                        <Button as="input" type="submit" variant="primary" value={'Find account'} />
                    </Form.Group>
                    </Form>
                </section>
                
            </div>
        )}
        </section>
    )
}